import DownloadAppUI from "../../molecules/common/DownloadAppUI";
import ResponsiveImage from "../../atoms/image/ResponsiveImage";
export default function FeaturedText({ data, className = "" }) {
  const Description = ({ data }) => {
    return data.map((item, count) => {
      return (
        <p
          className="lg:mt-3 md:mt-1.5"
          dangerouslySetInnerHTML={{ __html: item }}
          key={count}
        />
      );
    });
  };
  const TitleAndDescription = ({ data }) => {
    return (
      <div
        className={`container grid--default md:mb-10 lg:mb-10 md:fx md:fx--c ${className}`}
      >
        <article className="text-left lg:maxw-lg fx--o-2 mx-auto d-block">
          <h2
            className="text-lg  md:mb-2"
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
          <Description data={data.desc} />
        </article>
      </div>
    );
  };
  return Array.isArray(data) ? (
    data.map((item, count) => {
      <TitleAndDescription data={item} key={count} />;
    })
  ) : (
    <TitleAndDescription data={data} />
  );
}
